
import { Mixins, Component, Ref } from "vue-property-decorator";
import { onResize, onView } from "_mixins";
import { config, GSAP } from "_core";

@Component({
  name: "NextEventBlur",
})
export default class NextEventBlur extends Mixins(onResize, onView) {
  @Ref() visualElement: HTMLElement;

  rootClass = "p-home-next-event-blur";

  tallView = false;
  currentColor = false;
  animation = [];
  isPlaying = false;

  mounted() {
    this.init();
  }

  init() {
    this.checkScreenSizeAndAdjust();
  }

  onResize() {
    this.checkScreenSizeAndAdjust();
  }

  onView(inView: boolean) {
    if (inView && !this.animation.length) {
      this.animate();
      this.isPlaying = true;
    } else if (inView && !this.isPlaying) {
      this.animation.forEach((anim) => anim.play());
      this.isPlaying = true;
    } else if (!inView && this.isPlaying) {
      this.animation.forEach((anim) => anim.pause());
      this.isPlaying = false;
    }
  }

  checkScreenSizeAndAdjust() {
    this.tallView = config.dom.width < config.dom.height;
  }

  animate() {
    const tweenProperty = (target: HTMLElement, prop, min, max) => {
      const randomDur = GSAP.utils.random(1, 4, 0.2, true);
      const randomDelay = GSAP.utils.random(0.2, 1.5, 0.2, true);

      return GSAP.to(target, {
        [prop]: GSAP.utils.random(min, max),
        duration: randomDur(),
        delay: randomDelay(),
        ease: "ease.inOut",
        onComplete: tweenProperty,
        onCompleteParams: [target, prop, min, max],
      });
    };
    this.animation[0] = tweenProperty(this.visualElement, "scaleX", 0.75, 1.5);
    this.animation[1] = tweenProperty(this.visualElement, "scaleY", 0.75, 1.5);
    this.animation[2] = tweenProperty(this.visualElement, "x", -100, 100);
    this.animation[3] = tweenProperty(this.visualElement, "y", -100, 100);
  }
}
